import type { RouteRecordRaw } from 'vue-router'

// 登录 / 注册相关
export const loginRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login/index.vue'),
    meta: { backMode: 'exit' },
  },
  {
    path: '/email-login',
    name: 'email-login',
    component: () => import('@/pages/Login/EmailLogin/index.vue'),
  },
  {
    path: '/email-captcha',
    name: 'email-captcha',
    component: () => import('@/pages/Login/EmailCaptcha/index.vue'),
  },
]
